// ==================== Start hide BIS hidden options ====================
const hideBIShiddenOptions = function() {
  const bisBtns = document.querySelectorAll('.klaviyo-bis-trigger');
  if (bisBtns.length < 1) return;
  bisBtns.forEach(btn => btn.addEventListener('click', function() {
    setTimeout(() => {
      const iframe = document.querySelector('#klaviyo-bis-iframe');
      const doc = iframe.contentDocument ?
                  iframe.contentDocument :
                  (iframe.contentWindow ? iframe.contentWindow.document : iframe.document);
      const options = doc.querySelectorAll('#klaviyo-bis-modal select option');
      options.forEach(option => {
        if (option.textContent.includes('_')) option.remove();
        if (typeof discontinued_colors !== 'undefined'){
          const colors = discontinued_colors.split(',').map(c => c.trim());
          options.forEach(option => {
            let discontinued_option = colors.some(color => option.text.includes(color));
            if(discontinued_option){
              option.remove();
            }
          })
        }

      })
    }, 500);
  }));
}

document.addEventListener('DOMContentLoaded', hideBIShiddenOptions);
// ==================== End hide BIS hidden options ====================